import React from 'react'
import { useInternationalization } from '../../../features/i18n'
import { useViewport } from '../../../utils'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'

const MAX_TITLE_LENGTH = 70
const MAX_EXCERPT_LENGTH = 180

const CardFeatured = ({data, embed}) => {
  const {
    thumbnail,
    organization,
    title,
    category,
    excerpt,
    special
  } = data

  const { isMobile, isTablet } = useViewport()
  const { translate, language } = useInternationalization()
  const imageHeight = isMobile ? '150px' : '180px'
  const imageWidth = isMobile ? '150px' : '260px'
  const textColor = embed ? 'text-gray-444' : 'text-white'

  const checkTranslation = (stringOrObject) => {
    const target = stringOrObject
    return typeof target === 'string' ? target
      : target && target[language.name] ? target[language.name]
      : JSON.stringify(target)
  }

  // const titleRendered = typeof title === 'string' ? title : title[language.name]
  // const excerptRendered = typeof excerpt === 'string' ? excerpt : excerpt[language.name]
  const categoryRendered = category && category[language.name] ? category[language.name] : JSON.stringify(category)
  const titleRendered = excerptTrimmer(checkTranslation(title), MAX_TITLE_LENGTH)
  const excerptRendered = excerpt && excerpt[language.name] ? excerpt[language.name] : JSON.stringify(excerpt)
  const excerptTrimmed = excerptTrimmer(excerptRendered, MAX_EXCERPT_LENGTH)
  const isPlaceholder = thumbnail.toLowerCase().includes('placeholder')

  return (
    <div
      className={`rounded p-3 lg:p-5 flex flex-row w-full`}
      style={{
        boxShadow: `0px 4px ${embed ? '10px' : '20px'} rgba(0, 0, 0, 0.05)`,
        background: embed ? '#fff' : '#514B6B'
      }}
      title={checkTranslation(title)}
    >
      <div
        className={`bg-no-repeat bg-cover mr-3 lg:mr-5 ${isPlaceholder ? 'bg-left' : 'bg-center'} ${embed ? '' : isMobile || isTablet ? '' : 'mb-4'} lg:mb-0 rounded`}
        style={{height: imageHeight, minWidth: imageWidth, backgroundImage: "url('"+thumbnail+"')"}}
      />
      <div>
        <p className={`${textColor} text-xs lg:text-sm lg:font-bold`}>{categoryRendered}</p>
        <p className={`${embed ? 'text-gray-999' : 'text-white'} text-xs mb-2`}>{organization} /</p>
        {
          special &&
          <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>
            {translate('RESOURCE', 'special')}
          </div>
        }
        <h3 className={`text-sm lg:text-2xl font-bold lg:mb-2 font-primary ${embed ? '' : 'text-white'}`}>
          {titleRendered}
        </h3>
        {
          excerpt &&
          <div className={`hidden lg:block text-sm ${textColor}`} dangerouslySetInnerHTML={{__html: excerptTrimmed}} />
        }
      </div>
    </div>
  )
}

export { CardFeatured }
